import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://www.ajeetsinghbaddan.com'

// og:*/twitter:* tags live as static site-wide defaults in public/index.html:
// social-preview crawlers don't execute JS, so per-page values injected here
// would never be seen by them, and would just duplicate/conflict with the
// static ones in the live DOM for JS-rendering crawlers (e.g. Googlebot).
const SEO = ({ title, description, path = '/', noindex = false }) => {
  const url = `${SITE_URL}${path}`
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex ? <meta name="robots" content="noindex, follow" /> : <link rel="canonical" href={url} />}
    </Helmet>
  )
}

export default SEO
